var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge marry-plan",style:({ background: _vm.bgTextColor.color })},[_vm._v(" "+_vm._s(_vm.bgTextColor.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }